/*
 * VK Quote — demande de devis
 * Fichier ajoute. Ne modifie aucun comportement existant du theme :
 * le compteur d'en-tete est insere par ce script, pas par header.liquid.
 */
(function () {
  'use strict';

  if (window.VKQuote) return;

  var KEY = 'vk_quote_v2';
  var LOCK_MS = 700;
  var listeners = [];
  var lastAdded = null;

  /* ---------------------------------------------------------------- etat */

  function blank() { return { items: [], custom: [] }; }

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) {
        /* reprise des devis commences avant le changement de cle */
        var legacy = window.localStorage.getItem('vk_quote_v1');
        if (legacy) {
          window.localStorage.setItem(KEY, legacy);
          raw = legacy;
        }
      }
      if (!raw) return blank();
      var d = JSON.parse(raw);
      return {
        items: Array.isArray(d.items) ? d.items : [],
        custom: Array.isArray(d.custom) ? d.custom : []
      };
    } catch (e) {
      return blank();
    }
  }

  function write(d) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(d));
    } catch (e) {
      /* navigation privee : le devis reste valable pour la session */
    }
    listeners.forEach(function (fn) { try { fn(d); } catch (e) {} });
  }

  /* ------------------------------------- libelles des lignes hors catalogue */

  function customTitle(c) {
    c = c || {};
    if (c.mode === 'veh') {
      var v = (c.vehiculeAutre || c.vehicule || '').trim();
      if (!v) return 'V\u00e9hicule \u00e0 pr\u00e9ciser';
      return c.annee ? v + ' \u2014 ' + c.annee : v;
    }
    if ((c.libre || '').trim()) return c.libre.trim();
    var d = [c.largeur, c.serie].filter(Boolean).join('/');
    var full = (d + ' ' + (c.jante || '')).trim();
    return full || 'Dimension \u00e0 compl\u00e9ter';
  }

  function customMeta(c) {
    c = c || {};
    return c.mode === 'veh'
      ? 'Dimension \u00e0 d\u00e9terminer par nos soins'
      : 'Dimension demand\u00e9e';
  }

  function customIsEmpty(c) {
    c = c || {};
    if (c.mode === 'veh') return !(c.vehiculeAutre || c.vehicule || '').trim();
    return !((c.libre || '').trim() || (c.largeur || '').trim());
  }

  /* ------------------------------------------------------------------ API */

  var Q = {
    get: read,

    count: function () {
      var d = read();
      return d.items.length + d.custom.length;
    },

    add: function (line) {
      var d = read();
      var hit = d.items.filter(function (i) {
        return String(i.vid) === String(line.vid);
      })[0];

      if (hit) {
        hit.qty = Math.max(1, (parseInt(hit.qty, 10) || 1) + (parseInt(line.qty, 10) || 1));
      } else {
        d.items.push({
          vid: String(line.vid),
          sku: line.sku || '',
          title: line.title || '',
          variant: line.variant || '',
          url: line.url || '',
          image: line.image || '',
          qty: Math.max(1, parseInt(line.qty, 10) || 1)
        });
      }
      lastAdded = String(line.vid);
      write(d);
    },

    setQty: function (vid, qty) {
      var d = read();
      var n = parseInt(qty, 10);
      d.items.forEach(function (i) {
        if (String(i.vid) === String(vid)) i.qty = Math.max(1, isNaN(n) ? 1 : n);
      });
      write(d);
    },

    remove: function (vid) {
      var d = read();
      d.items = d.items.filter(function (i) { return String(i.vid) !== String(vid); });
      write(d);
    },

    setCustomQty: function (index, qty) {
      var d = read();
      var n = parseInt(qty, 10);
      if (d.custom[index]) d.custom[index].qty = Math.max(1, isNaN(n) ? 1 : n);
      write(d);
    },

    removeCustom: function (index) {
      var d = read();
      d.custom.splice(index, 1);
      write(d);
    },

    setCustom: function (rows) {
      var d = read();
      d.custom = rows;
      write(d);
    },

    clear: function () { write(blank()); },

    subscribe: function (fn) {
      listeners.push(fn);
      return function () {
        listeners = listeners.filter(function (f) { return f !== fn; });
      };
    },

    customTitle: customTitle,
    customMeta: customMeta,
    customIsEmpty: customIsEmpty,

    /* Bloc 1 : uniquement les produits presents au catalogue. */
    catalogueText: function () {
      var items = read().items;
      if (!items.length) return '';
      var out = [];
      items.forEach(function (it, i) {
        var line = (i + 1) + '. ' + it.title;
        if (it.variant && it.variant !== 'Default Title') line += ' - ' + it.variant;
        out.push(line);
        if (it.sku) out.push('   Reference : ' + it.sku);
        out.push('   Quantite  : ' + it.qty);
        if (it.url) out.push('   Fiche     : ' + window.location.origin + it.url);
        out.push('');
      });
      out.push('Total : ' + items.length + (items.length > 1 ? ' produits' : ' produit'));
      return out.join('\n');
    },

    /* Bloc 2 : dimensions absentes du catalogue, a chiffrer par l'operateur. */
    horsCatalogueText: function (withBanner) {
      var custom = read().custom;
      if (!custom.length) return '';
      var out = withBanner === false
        ? []
        : ['>>> A CHIFFRER - non presentes au catalogue <<<', ''];
      custom.forEach(function (c, i) {
        out.push((i + 1) + '. ' + customTitle(c));
        out.push('   Type     : ' + (c.mode === 'veh'
          ? 'vehicule communique, dimension a determiner'
          : 'dimension communiquee par le client'));
        out.push('   Quantite : ' + (c.qty || 1));
        out.push('');
      });
      out.push('Total : ' + custom.length + (custom.length > 1 ? ' lignes a chiffrer' : ' ligne a chiffrer'));
      return out.join('\n');
    },

    /* Recapitulatif complet, un seul bloc — utilise pour WhatsApp et l'impression.
       markers = true ajoute les asterisques que WhatsApp affiche en gras. */
    toText: function (markers) {
      var d = read();
      var out = [];
      var b = markers ? '*' : '';

      if (d.items.length) {
        out.push(b + 'PRODUITS DU CATALOGUE' + b);
        out.push('');
        out.push(Q.catalogueText());
        out.push('');
      }

      if (d.custom.length) {
        out.push(b + 'DIMENSIONS HORS CATALOGUE - A CHIFFRER' + b);
        out.push('');
        out.push(Q.horsCatalogueText(false));
        out.push('');
      }

      return out.join('\n').replace(/\n{3,}/g, '\n\n').trim();
    }
  };

  window.VKQuote = Q;

  /* ------------------------------------------------------------ utilitaires */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------------------- compteur */

  function paintCount(bump) {
    var n = Q.count();
    document.querySelectorAll('[data-vk-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
      if (bump && n > 0) {
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      }
    });
  }

  /* Insere le compteur dans l'en-tete sans modifier header.liquid. */
  function injectCounter(url) {
    if (document.querySelector('.vk-quote-icon')) return;
    var icons = document.querySelector('.header__icons');
    if (!icons) return;

    var a = document.createElement('a');
    a.href = url;
    a.className = 'header__icon vk-quote-icon link focus-inset';
    a.setAttribute('data-vk-open', '');
    a.setAttribute('aria-label', 'Mon devis');
    a.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
        '<path d="M5 2.5h7l3.5 3.5v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/>' +
        '<path d="M11.75 2.75V6.25h3.5M7 10.5h6M7 13.5h4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>' +
      '</svg>' +
      '<span class="visually-hidden">Mon devis</span>' +
      '<span class="vk-count-bubble" data-vk-count hidden>0</span>';

    var cart = icons.querySelector('#cart-icon-bubble');
    if (cart) icons.insertBefore(a, cart);
    else icons.appendChild(a);
  }


  /* --------------------------------------- pose automatique des boutons */
  /* Le bouton est insere par ce script. Aucun fichier du theme n'est modifie. */

  var LABEL = 'Ajouter au devis';

  function buildButton(product, context) {
    var wrap = document.createElement('div');
    wrap.className = 'vk-quote-add';
    wrap.setAttribute('data-vk-add', '');
    wrap.dataset.context = context;
    wrap.dataset.needsVariant = 'false';
    wrap.dataset.title = product.title || '';
    wrap.dataset.url = product.url || '';
    wrap.dataset.image = product.featured_image || '';

    var data = document.createElement('script');
    data.type = 'application/json';
    data.textContent = JSON.stringify((product.variants || []).map(function (v) {
      return { id: v.id, sku: v.sku || '', title: v.title || '' };
    }));
    wrap.appendChild(data);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button vk-qbtn' +
      (context === 'card' ? ' vk-qbtn--card' : ' button--full-width');
    btn.innerHTML =
      '<span class="vk-qbtn__label">' + esc(LABEL) + '</span>' +
      '<span class="vk-qbtn__done" aria-hidden="true">' +
        '<svg viewBox="0 0 20 20" fill="none"><path d="M4 10.5L8 14.5L16 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        'Ajout\u00e9' +
      '</span>';
    wrap.appendChild(btn);
    return wrap;
  }

  /* Clic depuis une carte de collection : on va chercher les variantes.
     Une seule variante -> ajout direct. Plusieurs -> on renvoie sur la fiche. */
  function addFromCard(wrap, btn) {
    var path = wrap.dataset.fetch;
    if (!path || wrap.dataset.busy === '1') return;

    wrap.dataset.busy = '1';
    btn.disabled = true;

    function fallback() {
      wrap.dataset.busy = '';
      btn.disabled = false;
      window.location.href = path;
    }

    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) { fallback(); return; }
        if (p.variants.length > 1) { fallback(); return; }

        wrap.dataset.busy = '';
        btn.disabled = false;

        var v = p.variants[0];
        Q.add({
          vid: v.id,
          sku: v.sku || '',
          variant: v.title || '',
          title: p.title || '',
          url: path,
          image: p.featured_image || '',
          qty: 1
        });

        flash(btn);
        paintCount(true);
        if (drawer) setTimeout(openDrawer, 260);
      })
      .catch(fallback);
  }

  function productPathFrom(href) {
    var m = String(href || '').match(/^(?:https?:\/\/[^\/]+)?(.*?\/products\/[^\/?#]+)/);
    return m ? m[1] : null;
  }

  function injectProductButton() {
    var zone = document.querySelector('.product-form__buttons');
    if (!zone || zone.querySelector('[data-vk-add]')) return;

    var path = productPathFrom(window.location.pathname);
    if (!path) return;

    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        if (zone.querySelector('[data-vk-add]')) return;
        p.url = path;
        zone.insertBefore(buildButton(p, 'product'), zone.firstChild);
      })
      .catch(function () {});
  }

  function injectCardButtons(selector) {
    if (!selector) return;
    document.querySelectorAll(selector).forEach(function (host) {
      if (host.querySelector('[data-vk-add]')) return;
      var link = host.closest('.card-wrapper, .card, li, .grid__item');
      link = link ? link.querySelector('a[href*="/products/"]') : null;
      var path = link ? productPathFrom(link.getAttribute('href')) : null;
      if (!path) return;

      var wrap = document.createElement('div');
      wrap.className = 'vk-quote-add';
      wrap.setAttribute('data-vk-add', '');
      wrap.dataset.context = 'card';
      wrap.dataset.url = path;
      wrap.dataset.fetch = path;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button vk-qbtn vk-qbtn--card';
      btn.innerHTML = '<span class="vk-qbtn__label">' + esc(LABEL) + '</span>' +
                      '<span class="vk-qbtn__done" aria-hidden="true">Ajout\u00e9</span>';
      wrap.appendChild(btn);
      host.appendChild(wrap);
    });
  }

  /* --------------------------------------------------------------- tiroir */

  var drawer, lastFocus;

  function stepperHtml(attrStep, attrQty, id, qty) {
    return '<span class="vk-stepper">' +
      '<button type="button" data-' + attrStep + '="-1" data-vid="' + esc(id) + '" aria-label="Diminuer">&minus;</button>' +
      '<input type="number" min="1" value="' + esc(qty) + '" data-' + attrQty + '="' + esc(id) + '" aria-label="Quantite">' +
      '<button type="button" data-' + attrStep + '="1" data-vid="' + esc(id) + '" aria-label="Augmenter">+</button>' +
    '</span>';
  }

  function itemLine(it) {
    var thumb = it.image
      ? '<img class="vk-line__thumb" src="' + esc(it.image) + '" alt="" loading="lazy" width="56" height="56">'
      : '<span class="vk-line__thumb"></span>';
    var variant = (it.variant && it.variant !== 'Default Title') ? ' \u00b7 ' + esc(it.variant) : '';
    var meta = it.sku ? '<p class="vk-line__meta">R\u00e9f. ' + esc(it.sku) + '</p>' : '';
    var isNew = String(it.vid) === String(lastAdded) ? ' is-new' : '';

    return '<div class="vk-line' + isNew + '">' + thumb +
      '<div><p class="vk-line__name">' + esc(it.title) + variant + '</p>' + meta + '</div>' +
      '<div class="vk-line__controls">' +
        stepperHtml('vk-step', 'vk-qty', it.vid, it.qty) +
        '<button type="button" class="vk-remove" data-vk-remove="' + esc(it.vid) + '">Retirer</button>' +
      '</div></div>';
  }

  function customLine(c, i) {
    return '<div class="vk-line">' +
      '<span class="vk-line__thumb vk-line__thumb--dim">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.4"/>' +
          '<circle cx="12" cy="12" r="3.4" stroke="currentColor" stroke-width="1.4"/>' +
        '</svg>' +
      '</span>' +
      '<div><p class="vk-line__name">' + esc(customTitle(c)) + '</p>' +
      '<p class="vk-line__meta">' + esc(customMeta(c)) + '</p></div>' +
      '<div class="vk-line__controls">' +
        stepperHtml('vk-cstep', 'vk-cqty', i, c.qty || 1) +
        '<button type="button" class="vk-remove" data-vk-cremove="' + i + '">Retirer</button>' +
      '</div></div>';
  }

  function renderDrawer() {
    if (!drawer) return;
    var d = read();
    var body = drawer.querySelector('[data-vk-drawer-body]');
    var countEl = drawer.querySelector('[data-vk-drawer-count]');
    var total = d.items.length + d.custom.length;

    countEl.textContent = total === 0
      ? 'Aucune ligne'
      : total + (total > 1 ? ' lignes' : ' ligne');

    if (!total) {
      body.innerHTML =
        '<div class="vk-hint" style="margin-top:2rem">' +
          '<p>Votre devis est vide. Ajoutez des pneus du catalogue, ou indiquez directement la dimension qu\u2019il vous faut.</p>' +
          '<a class="button button--secondary" href="' + esc(drawer.dataset.quoteUrl) + '">Indiquer une dimension</a>' +
        '</div>';
      return;
    }

    body.innerHTML = d.items.map(itemLine).join('') + d.custom.map(customLine).join('');
    lastAdded = null;
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    renderDrawer();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-vk-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  Q.openDrawer = openDrawer;
  Q.closeDrawer = closeDrawer;
  Q.renderDrawer = renderDrawer;

  /* -------------------------------------------------- bouton « au devis » */

  function variantIdFor(wrap) {
    var scope = wrap.closest('.product') || wrap.closest('form') || document;
    var input = scope.querySelector('form[action*="/cart/add"] input[name="id"]')
             || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : null;
  }

  function qtyFor(wrap) {
    var scope = wrap.closest('.product') || document;
    var input = scope.querySelector('input[name="quantity"]');
    return input ? (parseInt(input.value, 10) || 1) : 1;
  }

  function flash(btn) {
    btn.classList.add('is-added');
    btn.disabled = true;
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.disabled = false;
    }, LOCK_MS + 800);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vk-open]')) {
      e.preventDefault();
      if (drawer) openDrawer();
      return;
    }
    if (e.target.closest('[data-vk-drawer-close]') || e.target.closest('[data-vk-drawer-overlay]')) {
      closeDrawer();
      return;
    }

    var inDrawer = e.target.closest('.vk-drawer');

    var step = e.target.closest('[data-vk-step]');
    if (step && inDrawer) {
      var sid = step.getAttribute('data-vid');
      var cur = read().items.filter(function (i) { return String(i.vid) === String(sid); })[0];
      if (cur) Q.setQty(sid, cur.qty + parseInt(step.getAttribute('data-vk-step'), 10));
      renderDrawer();
      return;
    }

    var cstep = e.target.closest('[data-vk-cstep]');
    if (cstep && inDrawer) {
      var ci = parseInt(cstep.getAttribute('data-vid'), 10);
      var cc = read().custom[ci];
      if (cc) Q.setCustomQty(ci, (parseInt(cc.qty, 10) || 1) + parseInt(cstep.getAttribute('data-vk-cstep'), 10));
      renderDrawer();
      return;
    }

    var rm = e.target.closest('[data-vk-remove]');
    if (rm && inDrawer) {
      Q.remove(rm.getAttribute('data-vk-remove'));
      renderDrawer();
      return;
    }

    var crm = e.target.closest('[data-vk-cremove]');
    if (crm && inDrawer) {
      Q.removeCustom(parseInt(crm.getAttribute('data-vk-cremove'), 10));
      renderDrawer();
      return;
    }

    var btn = e.target.closest('.vk-qbtn');
    if (!btn || btn.disabled) return;

    var wrap = btn.closest('[data-vk-add]');
    if (!wrap) return;

    e.preventDefault();

    if (wrap.dataset.fetch) {
      addFromCard(wrap, btn);
      return;
    }

    if (wrap.dataset.needsVariant === 'true') {
      window.location.href = wrap.dataset.url;
      return;
    }

    var variants;
    try {
      variants = JSON.parse(wrap.querySelector('script[type="application/json"]').textContent);
    } catch (err) {
      return;
    }
    if (!variants.length) return;

    var vid = wrap.dataset.context === 'card' ? variants[0].id : variantIdFor(wrap);
    var variant = variants.filter(function (v) { return String(v.id) === String(vid); })[0] || variants[0];

    Q.add({
      vid: variant.id,
      sku: variant.sku,
      variant: variant.title,
      title: wrap.dataset.title,
      url: wrap.dataset.url,
      image: wrap.dataset.image,
      qty: wrap.dataset.context === 'card' ? 1 : qtyFor(wrap)
    });

    flash(btn);
    paintCount(true);
    if (drawer) setTimeout(openDrawer, 260);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.closest('.vk-drawer')) return;
    var q = e.target.closest('[data-vk-qty]');
    if (q) { Q.setQty(q.getAttribute('data-vk-qty'), q.value); return; }
    var cq = e.target.closest('[data-vk-cqty]');
    if (cq) { Q.setCustomQty(parseInt(cq.getAttribute('data-vk-cqty'), 10), cq.value); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* ------------------------------------------------------------------ init */

  function init() {
    drawer = document.querySelector('[data-vk-drawer]');
    if (!drawer) return;

    if (drawer.dataset.label) LABEL = drawer.dataset.label;

    if (drawer.dataset.injectCounter !== 'false') {
      injectCounter(drawer.dataset.quoteUrl);
    }
    if (drawer.dataset.injectProduct !== 'false') {
      injectProductButton();
    }
    if (drawer.dataset.cardSelector) {
      injectCardButtons(drawer.dataset.cardSelector);
    }

    Q.subscribe(function () { paintCount(false); });
    paintCount(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    if (!drawer) return;
    if (drawer.dataset.injectProduct !== 'false') injectProductButton();
    if (drawer.dataset.cardSelector) injectCardButtons(drawer.dataset.cardSelector);
    paintCount(false);
  });
})();
